import type { Resource } from '../../';
export const cart_cartItem_editDetails: Resource = {"default":"Edit Details"};
